export const rolesList = [
  { value: 'ADMIN', text: 'ADMIN' },
  { value: 'ACCOUNTANT', text: 'ACCOUNTANT' },
  { value: 'DISPATCHER', text: 'DISPATCHER' },
  { value: 'SUPERADMIN', text: 'SUPERADMIN' }
];
